import * as Yup from "yup";

const solicitudReingresoFormValidation = Yup.object().shape({
  observaciones: Yup.string().required("Campo obligatorio").max(8000, "Máximo 8000 caracteres"),
});

export default solicitudReingresoFormValidation;